var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCambodia(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_7601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 14.0789 0.528891 16.0342 1.45908 17.7391L12 18.7826L22.5409 17.7391C23.4711 16.0342 24 14.0789 24 12C24 9.92109 23.4711 7.96575 22.5409 6.26086L12 5.21737L1.45908 6.26086C0.528891 7.96575 0 9.92109 0 12H0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.45908 6.26086H22.5409C20.5057 2.53073 16.5485 0 12 0C7.45148 0 3.49434 2.53073 1.45908 6.26086Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 24C16.5485 24 20.5057 21.4693 22.5409 17.7391H1.45908C3.49434 21.4693 7.45148 24 12 24Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1739 14.3478V12.7826H15.1305V10.6957L14.087 9.65217L13.0435 10.6957V8.60869L12 7.5652L10.9565 8.60869V10.6957L9.91303 9.65217L8.86954 10.6957V12.7826H7.82611V14.3478H6.78262V15.913H17.2174V14.3478H16.1739Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_7601"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCambodia);
export default __webpack_public_path__ + "static/media/cambodia.9b76e3c0435dee69d6ed089f18696b60.svg";
export { ForwardRef as ReactComponent };